import { cartModel, modal } from 'assets/components';

import './productInfo.scss';

const state = {
  changeState: () => {},
  originalCTACopy: '',
  originalStickyCTACopy: '',
};

const getFrequency = function getProductFrequency() {
  const elSelect = document.querySelector('.js-productInfoFrequency');

  if (!elSelect) {
    return 0;
  }

  // support hidden input
  if (elSelect.getAttribute('type') === 'hidden') {
    return elSelect.value * 1;
  }

  // support select
  return elSelect.options[elSelect.selectedIndex].value * 1;
};

const getTrialVariantId = function getProductTrailVariantId({ option2, option3 }) {
  const variants = JSON.parse(document.querySelector('.js-trailSizeVariants').innerHTML);
  const variant = variants.find(item => (
    item.option2 === option2
    && item.option3 === option3
  ));

  return variant ? variant.id : null;
};

const getPackVariantId = function getProductPackVariantId() {
  const activeSize = document.querySelector('.js-size:checked');
  const activePack = document.querySelector('.js-pack:checked');
  const size = activeSize.getAttribute('id');
  const packId = activePack.getAttribute(`data-${size}`);

  return packId;
};

const getPackPrice = function getProductPackPrice() {
  const activePack = document.querySelector('.js-pack:checked');
  return activePack
    ? activePack.getAttribute('data-price')
    : '';
};

const resetCTAError = function resetProductCTAError() {
  const productButtons = document.querySelectorAll('.js-productInfoAdd')
  productButtons.forEach(elButton => {
    if(elButton.classList.contains('js-sticky-cta')) {
      if (state.originalStickyCTACopy) {
        elButton.innerHTML = state.originalStickyCTACopy;
        state.originalStickyCTACopy = '';
      }
    }else {
      if (state.originalCTACopy) {
        elButton.innerHTML = state.originalCTACopy;
        state.originalCTACopy = '';
      }
    }

    elButton.removeAttribute('disabled');
  });
};

const showCTAError = function showProductCTAError(errors) {
  const productButtons = document.querySelectorAll('.js-productInfoAdd')
  productButtons.forEach(elButton => {
    if(elButton.classList.contains('js-sticky-cta')) {
      state.originalStickyCTACopy = elButton.innerHTML;
      elButton.innerHTML = `Select ${(errors || []).join(', ')}`;
    }else {
      state.originalCTACopy = elButton.innerHTML;
      elButton.innerHTML = `Select ${(errors || []).join(', ')}`;
    }

    elButton.setAttribute('disabled', 'disabled');
  });

};

const onAddClick = function onProductAddToCartClick(e) {
  const $target = e.currentTarget;
  let activePack;
  const activeSize = document.querySelector('.js-size:checked') || document.querySelector('.js-size[type="hidden"]');
  const hasPack = document.querySelector('.js-pack');
  const hasTrialSize = document.querySelector('.js-trialSize');
  const hasTrialPack = document.querySelector('.js-trialPack');
  const activeTrialSize = document.querySelector('.js-trialSize:checked');
  const activeTrialPack = document.querySelector('.js-trialPack:checked');
  const isAltTemplate = document.querySelector('[data-alt-template]');
  const isTrial = !!(activeTrialPack && activeTrialPack.value);

  if (hasPack) {
    activePack = document.querySelector('.js-pack:checked');
  }

  if (
    !activeSize
    || (hasPack && !activePack)
    || (hasTrialPack && !activeTrialPack)
    || (hasTrialSize && !activeTrialSize)
  ) {
    const missingValues = [];
    if (!activeSize) {
      missingValues.push('Size');
    }

    if (hasPack && !activePack) {
      missingValues.push('Pack Size');
    }

    if (hasTrialPack && !activeTrialPack) {
      missingValues.push('Pack Size');
    }

    if (hasTrialSize && !activeTrialSize && !document.querySelector('.js-trial-size-autoselect')) {
      missingValues.push('Backup Size');
    }

    showCTAError(missingValues);

    return;
  }

  let id = activeSize.value;

  if (hasPack) {
    id = getPackVariantId();
  }

  // Handle Trial Kit
  if (hasTrialSize) {
    id = getTrialVariantId({
      option2: activeSize.getAttribute('data-option'),
      option3: activeTrialSize.value,
    });

    if (!id) {
      showCTAError(['Please select consecutive sizes']);
    }
  }

  let properties = {};

  if (getFrequency()) {
    properties = {
      shipping_interval_frequency: getFrequency(),
      shipping_interval_unit_type: cartModel.getFrequencyUnit(),
      // Trial kit pack selection
      ...(activeTrialPack ? { trial_pack: activeTrialPack.value } : {}),
      ...(isAltTemplate ? { _alt_template: true } : {}),
    };
  }

  // console.log('ATC');
  // console.log(properties);

  cartModel.add({
    id,
    quantity: 1,
    properties: properties
  })
    .then(() => {
      // console.log('ADD');

      // console.log(`TRIAL ADD! ${ isTrial }`);
      // console.log(cartModel.getState());

      const cartData = cartModel.getState();
      const itemsToRemove = {};

      if (cartData && cartData.items) {
        cartData.items.forEach((item) => {
          const itemProps = item.properties || {};

          if (item.title && item.title.toLowerCase().includes('high')) {
            if (isTrial && item.product_type !== 'trial' && !itemProps.trial_pack) {
              // console.log('REMOVE NON TRIAL ITEM');
              itemsToRemove[item.id] = 0;
            } else if (!isTrial && (item.product_type === 'trial' || itemProps.trial_pack)) {
              // console.log('REMOVE TRIAL ITEM');
              itemsToRemove[item.id] = 0;
            }
          }
        });

        // console.log(itemsToRemove);

        cartModel.updateMultiple(itemsToRemove)
          .then(() => {
            if (isTrial) { disableTrialAtc(); }
            redirectToCheckout($target);
          });
      } else {
        if (isTrial) { disableTrialAtc(); }
        redirectToCheckout($target);
      }
    });
};


const disableTrialAtc = function() {
  document.querySelectorAll('.js-productInfoAddTrial').forEach((el) => {
    el.setAttribute('disabled', true);
  });
};

const redirectToCheckout = function redirectToCheckout($target) {
  // console.log('REDIRECT');
  // console.log($target);
  if($target && $target.getAttribute("data-redirectCheckout")) {
    // Redirect to checkout
    if (getFrequency() > 0) {
      // console.log('FREQ');
      const shopName = $target.getAttribute("data-shop");
      const customerEmail = $target.getAttribute("data-email");
      const discountCode = $target.getAttribute('data-discountCode') ? `&discount=${ $target.getAttribute('data-discountCode') }` : '';
      var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
      var paramDomain = shopName ? `myshopify_domain=${shopName}` : '';
      try {
          var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
      } catch (err) {
          var paramLinker = '';
      }
      var paramCustomer = customerEmail ? `'&email=${customerEmail}'`: '';
      window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer + discountCode;
    } else {
        window.location = '/checkout';
    }
  }else{
    // console.log('STRAIGHT TO CART');
    // Redirect to cart
    state.changeState('/cart');
  }
}

const onPackChange = function onProductPackChange(ev, type = 'js-pack') {
  resetCTAError();
  const elView = document.querySelector('.js-productInfoPrice');
  const price = getPackPrice();
  if (price && elView) {
    elView.innerHTML = price;
  }

  const activePack = document.querySelector(`.${type}:checked`);
  const val = activePack ? activePack.value : '';
  const packStickyEl = document.querySelector(`.${type}Sticky`);

  if(packStickyEl) {
    packStickyEl.value = val;
  }
};

const onSizeClick = function onProductSizeGuideClick(ev) {
  ev.preventDefault();
  modal.open('modal-size-guide');
};

const onFitClick = function onProductFitLinkClick(ev) {
  ev.preventDefault();
  const ugcAnchor = document.querySelector('#shopify-section-product-briefs-ugc-images');
  if(ugcAnchor) {
    ugcAnchor.scrollIntoView({
      behavior: 'smooth', // Defines the transition animation. default: auto
      block: 'nearest', // Defines vertical alignment. "start|center|end|nearest" default: start
      inline: 'start' // Defines horizontal alignment. "start|center|end|nearest" default: nearest
    });
  }
}

const onHowManyClick = function onProductHowManyClick(ev) {
  ev.preventDefault();
  modal.open('modal-how-many');
};

const onSizeChange = function onProductSizeChange(ev, type = 'js-size') {
  resetCTAError();
  const activeSize = document.querySelector(`.${type}:checked`);
  const val = activeSize ? activeSize.value : '';
  const sizeElMobile = document.querySelector(`.${type}Mobile`);
  const sizeStickyEl = document.querySelector(`.${type}Sticky`);
  // Sync sizes
  sizeElMobile.value = val;
  sizeStickyEl.value = val;
};

const onSizeMobileChange = function onProductSizeChange(ev, type = 'js-size') {
  resetCTAError();
  const sizeEl = document.querySelector(`.${type}Mobile`);
  const val = sizeEl.options[sizeEl.selectedIndex].value;
  const targetSize = document.querySelector(`.${type}[value="${val}"]`);
  const sizeStickyEl = document.querySelector(`.${type}Sticky`);
  // Sync sizes
  if (targetSize) {
    targetSize.checked = true;
  }

  if(sizeStickyEl) {
    sizeStickyEl.value = val;
  }

  if (val) {
    // Disable first option [label]
    sizeEl.options[0].disabled = true;
  }
};

const onTrialSizeChange = function onProductTrailSizeChange(ev) {
  return onSizeChange(ev, 'js-trialSize');
};

const onTrialSizeMobileChange = function onProductTrailSizeMobileChange(ev) {
  return onSizeMobileChange(ev, 'js-trialSize');
};

const trialSizeAutoSelect = function(ev) {
  const target = ev.currentTarget;

  if (target) {
    const title = target.getAttribute('data-title');
    let trialInput;

    // console.log('TITLE');
    // console.log(title);

    if (title) {
      trialInput = document.querySelector(`.js-trialSize.js-option[data-title="${ title }"]`);
    }

    if (trialInput) {
      trialInput.click();
    }
  }
};

const bind = function bindProductInfo() {
  [].forEach.call(
    document.querySelectorAll('.js-productInfoAdd'),
    (el) => {
      el.addEventListener('click', onAddClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trial-size-autoselect'),
    (el) => {
      el.addEventListener('change', trialSizeAutoSelect);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-pack, .js-trialPack'),
    (el) => {
      el.addEventListener('change', onPackChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-sizeGuide'),
    (el) => {
      el.addEventListener('click', onSizeClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-ugc-images'),
    (el) => {
      el.addEventListener('click', onFitClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-howMany'),
    (el) => {
      el.addEventListener('click', onHowManyClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-size'),
    (el) => {
      el.addEventListener('change', onSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-sizeMobile'),
    (el) => {
      el.addEventListener('change', onSizeMobileChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialSize'),
    (el) => {
      el.addEventListener('change', onTrialSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialSizeMobile'),
    (el) => {
      el.addEventListener('change', onTrialSizeMobileChange);
    },
  );
};

const init = function initProductInfo(props = {}) {
  state.changeState = props.changeState;
  bind();
  modal.init();
};

const destroy = function destroyProductGallery() {
  [].forEach.call(
    document.querySelectorAll('.js-productInfoAdd'),
    (el) => {
      el.removeEventListener('click', onAddClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trial-size-autoselect'),
    (el) => {
      el.removeEventListener('click', trialSizeAutoSelect);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-pack'),
    (el) => {
      el.removeEventListener('change', onPackChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-sizeGuide'),
    (el) => {
      el.removeEventListener('click', onSizeClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-ugc-images'),
    (el) => {
      el.removeEventListener('click', onFitClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-size'),
    (el) => {
      el.removeEventListener('change', onSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-howMany'),
    (el) => {
      el.removeEventListener('click', onHowManyClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-sizeMobile'),
    (el) => {
      el.removeEventListener('change', onSizeMobileChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trailSize'),
    (el) => {
      el.removeEventListener('change', onTrialSizeChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-trialSizeMobile'),
    (el) => {
      el.removeEventListener('change', onTrialSizeMobileChange);
    },
  );

  modal.destroy();

  // Reset state
  state.originalCTACopy = '';
  state.originalStickyCTACopy = '';
};

export default {
  init,
  destroy,
};
